import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '../../contexts/OrganizationContext';
import InventoryLayout from './InventoryLayout';
import PlatformText from '../PlatformText';
import PlatformButton from '../PlatformButton';
import InventoryBackButton from './InventoryBackButton';
import { getPlatformClass } from '../../utils/platformUtils';

function ReportsPage() {
  const navigate = useNavigate();
  const platformClass = getPlatformClass();
  const isMobilePlatform = platformClass.includes('ios') || platformClass.includes('android') || platformClass.includes('pwa');

  return (
    <InventoryLayout>
      <div className={`inventory-container ${platformClass}`}>
        {/* Mobile App Bar */}
        {isMobilePlatform && (
          <div className="mobile-app-bar inventory-mobile-app-bar">
            <InventoryBackButton onClick={() => navigate('/inventory')}>Reports</InventoryBackButton>
          </div>
        )}

        {/* Desktop Header */}
        {!isMobilePlatform && (
          <div className="inventory-page-header">
            <div>
              <InventoryBackButton onClick={() => navigate('/inventory')}>Reports</InventoryBackButton>
              <PlatformText variant="body" className="inventory-page-subtitle">
                View inventory reports and analytics
              </PlatformText>
            </div>
          </div>
        )}

        <div className="inventory-empty-container">
          <h3>Inventory Reports</h3>
          <p>This page will show inventory reports and analytics.</p>
          <PlatformButton onClick={() => navigate('/inventory')}>
            Back to Dashboard
          </PlatformButton>
        </div>
      </div>
    </InventoryLayout>
  );
}

export default ReportsPage; 